import React from 'react';
import LazyLoad from '@nykaa/lazy-load';
import styled from '@nykaa/ui-components/styles/styled';
import { calculateHeight } from '../helper';
import Image from './image';
const BOTTOM_MARGIN_FOR_LAZY_LOAD = 250;
const RIGHT_MARGIN_FOR_LAZY_LOAD = 100;
const originalHeight = '156px';
const ImgBody = styled.div `
  text-align: center;
  height: ${({ height }) => height};
  position: relative;
  display: ${({ hasDynamicHeight }) => (hasDynamicHeight ? 'flex' : 'block')};
  justify-content: center;
  margin-bottom: ${({ hasDynamicHeight }) => (hasDynamicHeight ? '8px' : '0')};
  align-items: center;
  .lazy-load-wrap{
    width: 100%;
    height: 100%;
  }
`;
const PlaceHolder = styled.div `
  width: 100%;
  height: 156px;
  background: #dfe6e9;
`;
const CardImg = ({ src, alt, isLazy, hasDynamicHeight, cardHeight, cardWidth, maxCardHeight, }) => {
    const height = calculateHeight(hasDynamicHeight, cardHeight, originalHeight);
    return (React.createElement(ImgBody, { height: height, hasDynamicHeight: hasDynamicHeight }, isLazy ? (React.createElement(LazyLoad, { bottomMargin: BOTTOM_MARGIN_FOR_LAZY_LOAD, rightMargin: RIGHT_MARGIN_FOR_LAZY_LOAD, placeHolder: React.createElement(PlaceHolder, null), wrapperClassName: "lazy-load-wrap" },
        React.createElement(Image, { src: src, alt: alt, hasDynamicHeight: hasDynamicHeight, cardHeight: cardHeight, cardWidth: cardWidth, maxCardHeight: maxCardHeight }))) : (React.createElement(Image, { src: src, alt: alt, hasDynamicHeight: hasDynamicHeight, cardHeight: cardHeight, cardWidth: cardWidth, maxCardHeight: maxCardHeight }))));
};
export default CardImg;
